import { useMutation, useQueryClient } from 'react-query';

import { deleteTiltakEnergiplan } from '../../../../../services/api';
import { queryKeys } from '../../../../../utils/react-query';

export const useDeleteTiltak = (energiplanId: string | undefined) => {
  const queryClient = useQueryClient();

  const { mutate, isLoading } = useMutation((tiltakId: string) => deleteTiltakEnergiplan(tiltakId), {
    onSuccess: () =>
      Promise.all([
        queryClient.invalidateQueries([queryKeys.energyplanMeasures, energiplanId]),
        queryClient.invalidateQueries([queryKeys.measures])
      ])
  });

  return { deleteTiltak: mutate, isLoading };
};
